import React from 'react'
import { UpgradeBullet } from '@chegg-wt/core/types/core'
import * as Styled from './styled'

interface Props {
  point: UpgradeBullet
  freeTrial: boolean
}

interface BulletPointProps {
  bullet: string
  dataTestId: string
}

const UpgradeBulletPoint: React.FC<BulletPointProps> = ({ bullet, dataTestId }) => {
  return (
    <Styled.BulletPoint key={bullet} data-test={dataTestId}>
      {bullet}
    </Styled.BulletPoint>
  )
}

const BulletPoint: React.FC<Props> = ({ point, freeTrial }) => {
  if (!freeTrial && point.isFreeTrial) {
    return null
  }
  return <UpgradeBulletPoint bullet={point.bullet} dataTestId={point.dataTestId} />
}

export default BulletPoint
